"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronLeftSmallIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var ChevronLeftSmallIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M11.2618138,14.7530611 C10.0178163,13.517245 9,12.5033559 9,12.4999747 C9,12.4878975 13.5239265,8 13.5361002,8 C13.5429331,8 13.7712589,8.22132081 14.0434919,8.49182412 L14.5384615,8.98364813 L12.7624706,10.7479715 L10.9864796,12.5122949 L12.7561278,14.2703168 L14.525775,16.0283394 L14.0373017,16.5141692 C13.768641,16.7813757 13.5431578,17 13.5362279,17 C13.529298,17 12.5058112,15.9888771 11.2618138,14.7530611 Z" }))); };
exports.ChevronLeftSmallIcon = ChevronLeftSmallIcon;
